export default __webpack_public_path__ + "static/hiblokcase2-ffce23ed39875a157fe6bc46715680f7.png";